import { BaseServiceSetup, utils } from '@ad-engine/core';
import { communicationService, eventsRepository } from '@ad-engine/communication';

const logGroup = 'assertive-yield';

interface WindowWithAssertive extends Window {
	assertive: AssertiveConfig;
}

type StringOrNull = string | null;

interface AssertiveConfig {
	debug?: boolean;
	entityId: string;
	analytics: {
		integrations: {
			webAnalytics: boolean;
		};
		logUnfilled: boolean;
		custom?: {
			layout?: StringOrNull;
			userState?: StringOrNull;
			[key: `custom_${number}`]: StringOrNull;
		};
	};
	hash: {
		generator: string;
		values: number;
		key: string;
	};
}

declare let window: WindowWithAssertive;

export class AssertiveYield extends BaseServiceSetup {
	private ENTITY_ID = 'grbqPYtkDC5HPMrgd';
	private SCRIPT_URL = `https://${this.ENTITY_ID}.ay.delivery/client-v2.js`;

	private setupAssertiveConfig() {
		window.assertive = {
			debug: false, // for dynamic debug see: https://suite.assertiveyield.com/docs/yield-intelligence/tracking-client-documentation#debug-mode
			entityId: this.ENTITY_ID,
			analytics: {
				integrations: {
					webAnalytics: true,
				},
				logUnfilled: true,
				custom: {
					// optional dimensions for custom data, they expect null or string
					layout: null,
					userState: null,
					custom_1: null,
					custom_2: null,
					custom_3: null,
					custom_4: null,
				},
			},
			hash: {
				generator: 'server',
				values: 1,
				key: 'ay',
			},
		};
	}

	private loadScript() {
		utils.logger(logGroup, 'loading', this.SCRIPT_URL);

		utils.timedPartnerScriptLoader
			.loadScriptWithStatus(this.SCRIPT_URL, logGroup)
			.then(() => {
				utils.logger(logGroup, 'ready');
			})
			.catch((e) => {
				utils.logger(logGroup, 'error', e);
				// Send out an event, which will emit a tracking event to DataWarehouse (AWS Athena)
				communicationService.emit(eventsRepository.PARTNER_LOAD_STATUS, {
					// LogGroup here is synonymous with the partner name
					status: logGroup + '_error_loading',
				});
			});
	}

	call(): void {
		if (!this.isEnabled('icAssertiveYield')) {
			utils.logger(logGroup, 'disabled');
			return;
		}

		this.setupAssertiveConfig();
		this.loadScript();
	}
}
